import { render, staticRenderFns } from "./ChannelGroupInfoModal.vue?vue&type=template&id=0f0eaa62&scoped=true&"
import script from "./ChannelGroupInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0eaa62",
  null
  
)

export default component.exports